module.exports = __webpack_public_path__ + "img/product-strawberry.10b8b790.png";